import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">用户心声</h2>
          <p className="mt-2 text-sm text-foreground-500">真实用户评价 · 品质口碑见证</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 mt-4 text-accent-500 text-xs">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}